import { Component, Input, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { OcasService } from "../Service/ocas.service";
import { environment } from "../../../../src/environments/environment";
import { ToastNotificationService } from "app/shared/toast-notification/toast-notification.service";
import { CarrierService } from "app/services/carrier.service";
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  selector: "app-display-questionnaire",
  templateUrl: "./display-questionnaire.component.html",
  styleUrls: ["./display-questionnaire.component.scss"],
})
export class DisplayQuestionnaireComponent implements OnInit {
  questionsData: any;
  questionnairesForm: FormGroup;
  carrier_id;
  responseFileId;
  filebytes: string;
  filetype: any;
  realFile: any;
  getCarrierData;
  message: any;
  isLoading: boolean = false;
  img: any;
  pdfSrc: any;
  showDocument: any = [];
  ocausID;
  questionOcausId;
  showTableData;
  userCreated;
  showTable;
  showQuestionData: boolean = false;
  @Input() data: string;

  @Input() isInProgress: boolean;
  constructor(
    private _ocasService: OcasService,
    private _fb: FormBuilder,
    private _route: ActivatedRoute,
    private toastService: ToastNotificationService,
    private _carrierService: CarrierService,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {}

  ngOnInit(): void {
    //.log(this.data, "C@@@@@@");
    this.carrier_id = this.data;
    this.getOcausData();
  }

  getOcausData() {
    this.getQuestions();
    this.createQuestionForm();
    this._carrierService
      .getCarrierById(this.carrier_id)
      .subscribe((response: any) => {
        this.getCarrierData = [];
        this.getCarrierData = response;
      });
    this._ocasService
      .getSavedQuestionnaireById(this.carrier_id)
      // .subscribe(
      //   (savedQesData: any) => {
      //   console.log(savedQesData, "@@@@@@@@@@@@@@@@@@@@@@");

      //   if (savedQesData) {
      //     this.showDocument = [];
      //     savedQesData.forEach((element: any, i) => {
      //       this.questionsData.findIndex((ele, i) => {
      //         if (element.Ocas_Type.id === ele.Ocas_Type.id) {
      //           if (element.Document != null) {
      //             this.showTableData = element?.Document?.id;
      //             this.showDocument.push(element);
      //             this.showDocument.forEach((ele) => {
      //               this.showTable = ele;
      //               this.userCreated = ele.id;
      //             });
      //           }

      //           if (element.Carrier_Ocas_Type.note != null) {
      //             this.questionnairesForm?.controls.questionnaires["controls"][
      //               i
      //             ]["controls"].answer.patchValue("YES");
      //           } else {
      //             this.questionnairesForm?.controls?.questionnaires["controls"][
      //               i
      //             ]["controls"].answer.patchValue("NO");
      //           }
      //           this.questionnairesForm?.controls.questionnaires["controls"][i][
      //             "controls"
      //           ].note.patchValue(element.Carrier_Ocas_Type.note);
      //         }
      //       });
      //     });
      //   } else {
      //     console.log("Data is not save..........");
      //   }
      // }
      // )

      .subscribe(
        (savedQesData: any) => {
          console.log(savedQesData, "@@@@@@@@@@@@@@@@@@@@@@");

          if (savedQesData) {
            this.showDocument = [];
            savedQesData.forEach((element: any, i) => {
              this.questionsData.findIndex((ele, i) => {
                if (element.Ocas_Type.id === ele.Ocas_Type.id) {
                  if (element.Document != null) {
                    this.showTableData = element?.Document?.id;
                    this.showDocument.push(element);
                    this.showDocument.forEach((ele) => {
                      this.showTable = ele;
                      this.userCreated = ele.id;
                    });
                  }

                  if (element.Carrier_Ocas_Type.note != null) {
                    this.questionnairesForm?.controls.questionnaires[
                      "controls"
                    ][i]["controls"].answer.patchValue("YES");
                  } else {
                    this.questionnairesForm?.controls?.questionnaires[
                      "controls"
                    ][i]["controls"].answer.patchValue("NO");
                  }
                  this.questionnairesForm?.controls.questionnaires["controls"][
                    i
                  ]["controls"].note.patchValue(element.Carrier_Ocas_Type.note);
                }
              });
            });
          } else {
            console.log("Data is not save..........");
          }
        },
        (err) => {
          if (err.status === 404) {
            this.showQuestionData = true;
          }
          console.log(err, "jjjjjjjjjjjjjjjjjj");
        }
      );
    this.showQuestionData = false;
  }
  getQuestions() {
    this.message = "Please wait...";
    this.isLoading = true;
    this._ocasService.getQuestionnaires().subscribe((response: any) => {
      this.isLoading = false;
      this.questionsData = response || [];

      this.addItems(response);
    });
  }

  get questionnareForm() {
    // this.questionnairesForm.controls["questionnaires"]["controls"].disable();
    return this.questionnairesForm.controls["questionnaires"][
      "controls"
    ] as FormArray;
  }
  createQuestionForm() {
    this.questionnairesForm = this._fb.group({
      questionnaires: new FormArray([]),
    });
  }
  createItem(): FormGroup {
    return this._fb.group({
      answer: new FormControl(null),
      note: new FormControl(""),
      files: new FormControl([]),
    });
  }
  get questionnaires() {
    return this.questionnairesForm.get("questionnaires") as FormArray;
  }
  addItems(questionsData: any): void {
    for (let index = 0; index < questionsData.length; index++) {
      this.questionnaires.push(this.createItem());
    }
  }
  getParticularQuestion(idx: number) {
    return this.questionnaires.controls[idx];
  }
  getQuestionFiles(idx: number) {
    return this.getParticularQuestion(idx).get("files");
  }
  pushFileIntoQuestion(event, i) {
    const files = this.getQuestionFiles(i);

    let filesAmount = event.target.files.length;

    if (filesAmount > 10) {
      this.toastService.error(`Please select less than 10 file`, "Upload File");
      return;
    }

    for (let findFile = 0; findFile < filesAmount; findFile++) {
      let allowedFileSize =
        environment.authWebApi.systemData.Configurations.find(
          (p) => p.Code == "MaxUploadMB1"
        );
      let maxAllowedSize = allowedFileSize.Value; //it is in MB

      let document_sizeMB = this.getFileSize(event.target.files[findFile]);

      if (maxAllowedSize <= document_sizeMB) {
        this.toastService.error(
          "Please select image of less than 5 MB",
          "Upload File"
        );
        return;
      }

      let typesOfFile = [];
      if (event.target.files[findFile].type !== "") {
        typesOfFile = this.getFileType(event.target.files[findFile]);
      }

      if (typesOfFile.length <= 0 || typesOfFile[1].toLowerCase() !== "pdf") {
        this.toastService.error(
          "Uploaded file is not a valid. PDF files are allowed",
          "UploadFile"
        );
        return;
      }

      files.value.push(event.target.files[0]);
    }
  }
  removeFileFromQuestion(questionIdx: number, idxToRemove: number) {
    const files = this.getQuestionFiles(questionIdx);
    files.value.splice(idxToRemove, 1);
  }

  async questionnairesHandler() {
    this.isLoading = true;
    let success: boolean = false;
    const questions = this.questionnairesForm.value.questionnaires;
    if (this.carrier_id) {
      questions.forEach(async (question, i) => {
        if (question.answer) {
          const payload: any = {};
          payload.note = question.note;
          payload.carrier_id = +this.carrier_id;
          payload.ocas_type_id = this.questionsData[i].Ocas_Type.id;
          payload.user_created = this.questionsData[i].Ocas_Type.user_created;
          payload.user_modified = this.questionsData[i].Ocas_Type.user_modified;
          try {
            await this.postQuestionnaires(payload).then((savedQuestion) => {
              if (savedQuestion) {
                this.responseFileId = savedQuestion["id"];
                if (savedQuestion["id"]) {
                  const files: Array<File> = questions[i].files;
                  files.forEach(async (file, i) => {
                    const formData: FormData = new FormData();
                    formData.append("FileName", "" + new Date().getTime());

                    formData.append(
                      "TypeOfFile",
                      this.getFileType(file).join("/")
                    );
                    formData.append("FileSize", "" + this.getFileSize(file));
                    formData.append("carrier_ocas_id", savedQuestion["id"]);
                    formData.append("Notes", " ");
                    formData.append("CarrierID", this.carrier_id);
                    formData.append("CarrierName", this.getCarrierData.name);
                    formData.append("UserLastName", this.getCarrierData.name);
                    formData.append(
                      "user_created",
                      this.getCarrierData.user_created
                    );
                    formData.append(
                      "user_modified",
                      this.getCarrierData.user_modified
                    );
                    const reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = async () => {
                      const filebytes = reader.result?.toString().split(",")[1];
                      formData.append("File", filebytes);
                      reader.removeEventListener;

                      try {
                        //this.isLoading = true;
                        const fileUploadData = await this.uploadFile(formData);

                        if (fileUploadData) {
                          success = true;
                          this.getOcausData();
                        } else {
                          success = false;
                        }
                      } catch (error) {}
                    };
                  });
                }
              }
            });
          } catch (error) {}
        }
      });
    }
    // this.isLoading = false;
    if (success) {
      this.toastService.success("Questionnaire successfully saved", "");
    }
  }

  getFileName(file: File) {
    return file.name;
  }
  getFileType(file: File) {
    const typesOfFile = file.type.split("/");
    return typesOfFile;
  }

  getFileSize(file: File) {
    return file.size / 1000000;
  }

  async postQuestionnaires(bodyData: any) {
    return await this._ocasService.postQuestionnaires(bodyData).toPromise();
  }
  uploadFile(formDataValue) {
    return this._ocasService.uploadDocument(formDataValue).toPromise();
  }
  handleNoAnswer(event, idx: number) {
    const question = this.getParticularQuestion(idx);
    question.get("files").reset();
    question.get("note").reset();
  }
  handleYesAnswer(event, idx: number) {
    const question = this.getParticularQuestion(idx);
    question.get("note").setValue("");
    question.get("files").setValue([]);
  }

  viewDoc(documenlink, fileName) {
    const id = documenlink.toString().split("#")[1];
    this.isLoading = true;
    this.pdfSrc = null;
    this.img = null;
    // let ext = fileName.substring(fileName.length - 3, fileName.length);
    this._ocasService.downloadpdf(id).subscribe((x: File) => {
      let objectURL = URL.createObjectURL(x);
      this.pdfSrc = objectURL;
      this.isLoading = false;
    });
  }

  removeUploadedFile(fileId) {
    this.isLoading = true;
    this._ocasService
      .deleteDocumentFormList(fileId.id)
      .subscribe((deleteFile: any) => {
        this.isLoading = false;
        if (deleteFile == true) {
          this.toastService.success("File deleted", "Delete file");
          this.getOcausData();
        } else {
          this.toastService.error("Please try again...", "Delete Document");
        }
      });
  }
  backList() {
    this.router.navigateByUrl("/carrier/accounts/VCA");
  }
  getTotalFiles(data: Array<any>, ocasId) {
    let count = 0;

    data.forEach((doc) => {
      if (doc?.Ocas_Type.id == ocasId) {
        count = count + 1;
      }
    });

    return count;
  }
}
